import apiClient from "./apiClient";


const testimonials = [
  {
    name: 'P Sibaram Patra',
    designation: 'Founder, Maa Laxmi Engineering',
    message: 'Excellent service and top-notch technical skills. The team exceeded our expectations.',
  },
  {
    name: 'Sibraj',
    designation: 'CEO, SibraZen',
    message: 'Softition transformed our outdated system into a sleek and functional platform. Highly recommend!',
  },
  {
    name: 'Prabhu Charan',
    designation: 'CTO, Chakayatra',
    message: 'Quick delivery and fantastic communication throughout the project lifecycle.',
  },
  {
    name: 'Jyotishree',
    designation: 'Manager, Shreezaar',
    message: 'Reliable, innovative, and professional. I would definitely work with Softition again!',
  }
];


export const getTestimonials = async () => {
  try {
    const response = await apiClient.get("/testimonials");
    return response.data;
  } catch (error) {
      console.error("Error fetching testimonials:", error);
      //throw error; // rethrow so component can handle it
      return testimonials;
  }
};
